import { ColDef } from 'ag-grid-community';
import { AgGridColumns, AgGridFilterParams } from '../../../Compliance/AgGrid';
import { WeissmanDateFormatPipe, WeissmanTimestampMsecFormatPipe } from '../../../UI-Lib/Pipes/Date-Format/date-formatting.pipe';

export function numberColumn(headerName: string, field: string): ColDef {
    return {
        headerName: headerName,
        field,
        width: AgGridColumns.textColumnSmallWidth,
        filter: 'agNumberColumnFilter',
        filterParams: AgGridFilterParams.numberFilterParams,
        floatingFilterComponentParams: AgGridFilterParams.numberFloatingFilterParams,
    };
}

export function textColumn(headerName: string, field: string): ColDef {
    return {
        headerName: headerName,
        field: field,
        width: AgGridColumns.textColumnWidth,
        filter: 'agTextColumnFilter',
        filterParams: AgGridFilterParams.textFilterParams,
        floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
    };
}

export function timestampColumn<TModel>(headerName: string, field: keyof TModel, timestampPipe: WeissmanTimestampMsecFormatPipe): ColDef {
    return {
        headerName: headerName,
        field: field as string,
        width: AgGridColumns.textColumnMedWidth,
        valueFormatter: (params) => {
            const model = params.data as TModel | undefined;
            const value = model ? (model[field] as Date | undefined) : undefined;

            if (!value) {
                return '';
            }

            return timestampPipe.transform(value);
        },
    };
}

export function dateColumn<TModel>(headerName: string, field: keyof TModel, datePipe: WeissmanDateFormatPipe): ColDef {
    return {
        headerName: headerName,
        field: field as string,
        width: AgGridColumns.textColumnMedWidth,
        valueFormatter: (params) => {
            const model = params.data as TModel | undefined;
            const value = model ? (model[field] as Date | undefined) : undefined;

            if (!value) {
                return '';
            }

            return datePipe.transform(value);
        },
    };
}

export function rowVersionColumn<TModel>(headerName: string, field: keyof TModel): ColDef {
    return {
        headerName: headerName,
        field: field as string,
        width: AgGridColumns.textColumnWidth,
        filter: 'agTextColumnFilter',
        filterParams: AgGridFilterParams.textFilterParams,
        floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
        valueFormatter: (params) => {
            const model = params.data as TModel | undefined;
            const value = model ? (model[field] as string | undefined) : undefined;

            if (!value || value.length === 0) {
                return '';
            }

            return value;
        },
    };
}
